import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import ReactGA from "react-ga4";

ReactGA.initialize("G-VE6WJBEYTJ");

ReactDOM.render(<App />, document.getElementById("root"));
